import { render, staticRenderFns } from "./addPost.vue?vue&type=template&id=2109a568"
import script from "./addPost.vue?vue&type=script&lang=js"
export * from "./addPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports